export default __webpack_public_path__ + "static/media/swapArrow.511f5769.png";